
editor2ContextMenuDirective.$inject = ['$translate'];
export function editor2ContextMenuDirective($translate) {

  return {
    restrict: 'E',
    template: require('./context-menu.directive.html'),
    require: '^^codemirrorAndToolbar',
    scope: {
      spellSuggestions: '<',
      selectedLink: '<'
    },
    link: function (scope, element, attrs, codemirrorAndToolbarController) {

      scope.openMenu = openMenu;
      scope.suggestionSelected = suggestionSelected;
      
      init();


      function openMenu($mdMenu, $event) {
        $mdMenu.open($event);
      }


      function suggestionSelected(suggestion) {
        codemirrorAndToolbarController.spellSuggestionClicked(suggestion);
      }


      function init() {
        // Let's bring the focus back to the editor when the context menu is closing, either by pressing escape or clicking somewhere
        const unsubscribeFn = scope.$on("$mdMenuClose", () => codemirrorAndToolbarController.contextMenuClosing());
        scope.$on('$destroy', unsubscribeFn);
      }
    }
  }
}
